import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {ApiUi} from '@api/components'
import {DirectMessages} from '@client/direct-messages'
import {EventBus} from '@client/event-bus'
import {backFromChatEvent} from '@client/events'
import {Sync} from '@client/sync'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {Badge} from '@components/common/base/badge'
import {LinkButton} from '@components/common/base/buttons'
import {rightPanelStore} from '@components/right-panel/right-panel'
import {withUpdaters} from '@containers/updaters'
import {LocationUpdater} from '@containers/updaters/location-updater'
import {SyncUpdater} from '@containers/updaters/sync-updater'
import {ChatUtils} from '@extensions/chat-utils'
import {DivWithHint} from '../../common/hint/hint'

const NewMessagesBadge = withUpdaters(
  SyncUpdater({companyType: 'current', filter: '*', debounceTime: 1000}),
  SyncUpdater({companyType: 'profile', filter: '*', debounceTime: 1000}),
  LocationUpdater()
)(() => {
  const box = Sync.getCurrentSandbox()
  const curHub = ChatUtils.getChatFromCurrentUrl()
  const user = DirectMessages.getDirectChatUser(curHub)
  const newMsg =
    ChatUtils.newMessagesFromAllPersonalChats(user ? user.id : undefined) +
    ChatUtils.newMessagesFromAllTaskChats(
      box,
      'withCurrentUser',
      !user && curHub ? curHub.id : undefined
    ) +
    ChatUtils.newMessagesFromAllGroupChats(
      box,
      !user && curHub ? curHub.id : undefined
    )

  return newMsg > 0 ? (
    <Badge type="packed" unread>
      {`+${newMsg}`}
    </Badge>
  ) : null
})

const TwChatNav = tw.div`
  cursor-pointer
  h-48
  pl-24
  flex
  items-center
  justify-between
`

const goBack = () => {
  Tracking.send(TrackingEvent.chatPanelBack)
  EventBus.dispatch(backFromChatEvent())
}

export const ChatNav = observer(() => {
  // TODO fix edit pin, stickers, task name
  // useGlobalKeyDown({
  //   anyKey: e => {
  //     if (e.key === 'Backspace' || e.code === 'Backspace') {
  //       goBack()
  //       return true
  //     }
  //     return false
  //   }
  // })
  const {openedBlock} = rightPanelStore.state.taskChatList
  const title =
    openedBlock === 'search'
      ? Lang.msg.toSearchResults
      : Lang.context.rightPanel.toAllChats

  return (
    <TwChatNav onClick={goBack}>
      <LinkButton icon="IconArrowLeft" color="primary" noPaddings>
        <div className="flex items-center justify-between gap-8">
          <div className="font-semibold">{title}</div>
          {openedBlock !== 'search' && (
            <DivWithHint content={Lang.msg.backNotifyHint}>
              <NewMessagesBadge />
              <ApiUi category="chat-nav" />
            </DivWithHint>
          )}
        </div>
      </LinkButton>
    </TwChatNav>
  )
})
